import type { ProgramBuilderState } from '@entities/program'

export type ProgramDraftBackup = {
	program_id: string
	draft: ProgramBuilderState
	baseline: ProgramBuilderState
	etag: string
	saved_at: string
}

export const programDraftKey = (programId: string) => `tisit:admin:program-draft:${programId}`

const browserSessionStorage = (): Storage | null =>
	typeof window === 'undefined' ? null : window.sessionStorage

export const readProgramDraft = (
	programId: string,
	storage: Storage | null = browserSessionStorage(),
): ProgramDraftBackup | null => {
	if (!storage) return null
	try {
		const raw = storage.getItem(programDraftKey(programId))
		if (!raw) return null
		const value = JSON.parse(raw) as ProgramDraftBackup
		return value.program_id === programId && value.draft && value.baseline && value.etag
			? value
			: null
	} catch {
		return null
	}
}

export const writeProgramDraft = (
	backup: ProgramDraftBackup,
	storage: Storage | null = browserSessionStorage(),
) => {
	try {
		storage?.setItem(programDraftKey(backup.program_id), JSON.stringify(backup))
	} catch {
		return false
	}
	return Boolean(storage)
}

export const removeProgramDraft = (
	programId: string,
	storage: Storage | null = browserSessionStorage(),
) => {
	try {
		storage?.removeItem(programDraftKey(programId))
	} catch {
		return false
	}
	return Boolean(storage)
}
